var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlertTriangle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0v-4A.5.5 0 0 1 8 5ZM8.625 11.375a.625.625 0 1 1-1.25 0 .625.625 0 0 1 1.25 0Z",
    fill: "#FAE527"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.819 3.872c.954-1.705 3.408-1.705 4.362 0l3.588 6.406c.933 1.667-.271 3.722-2.181 3.722H4.412c-1.91 0-3.114-2.055-2.18-3.722l3.587-6.406Zm3.49.488a1.5 1.5 0 0 0-2.618 0l-3.587 6.407A1.5 1.5 0 0 0 4.412 13h7.176a1.5 1.5 0 0 0 1.309-2.233L9.309 4.36Z",
    fill: "#FAE527"
  })));
};
export default SvgAlertTriangle;